const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/**
 * Builds schema fragments for the NavHeadingRecordList.
 * This is a view-only block that displays records in a navigation list.
 * It creates a relation entry for route access checks but should NOT override
 * canonical required arrays defined by Forms.
 */
function asDataDictionary(hNode, context, parentAccessRestrictions) {
    const { namespace, relation, children } = hNode;
    const accessRestrictions = actionUtils.getNodeAccessRestrictions(hNode, context, parentAccessRestrictions);
    const normalizedAction = actionUtils.normalizeAction('list');
    if (accessRestrictions.hidden) return [{}, {}];

    // Process children and collect their contributions
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(
                child,
                context,
                accessRestrictions
            );
            return [
                moduleRegistration.mergeSubDataDictionaries(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    // Build relation entry for route access checks
    // Note: This is a view-only block so we don't set required - that's defined by Forms
    const relationSchema = {
        type: 'object',
        properties: { ..._partialTypeDefinition },
        'x-accessRestrictions': accessRestrictions,
        'x-forAction': normalizedAction
    };

    // Use relation-aware merge to avoid overwriting canonical required arrays
    const subDataDictionary = moduleRegistration.mergeSubDataDictionaries(
        {
            [namespace]: {
                [relation]: relationSchema
            }
        },
        _subDataDictionary
    );

    return [subDataDictionary, {}];
}

module.exports = { asDataDictionary };
